import axios from "axios";
import { ICallListParams } from "../models/call.model";

export const getCalls = async (params: ICallListParams) => {
  const res = await axios.get("/call", { params });
  return res;
};

